import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Markdown from 'react-markdown';

/*TO DO: 
    - subcategories
    - routing from main page
    */

class CategoryPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
        category: '',
        subcategories: '',
        selected: '', // this is the subcategory the user selects
        selectedIndex: ''
    }

}
click = (click, selected) => {
  //console.log(selected);
  this.setState({ 
      selected: selected
  });
}

componentWillReceiveProps(nextProps) {
    let subcategories = [];
    //console.log(nextProps.category);
    Object.keys(nextProps.category).forEach(subcat => {
      subcategories.push(subcat);
    });
    this.setState({
      category: nextProps.category,
      subcategories: subcategories,
      selected: subcategories[0]
    });
  }

 render() {
   return(
      <div>
      { this.state.category&&true ?
        <div>
      <header id="header">
        <ul className="actions">
        {this.state.subcategories.map((subcategory) => {
          let style;
          if (subcategory === this.state.selected) {
            style = "button primary"
          }
          else {
            style = "button"
          }
          return <li>
            <button 
            onClick={(click) => this.click(click, subcategory)} 
            className={style}>
              {subcategory.split(/(?=[A-Z])/).join(" ")}
            </button>
          </li>
        })}
        </ul>
        </header>
          <Markdown>{this.state.category[this.state.selected]}</Markdown>
          </div>
        :
        <p>nothing to show at this time</p>

      }
      </div>
   );
 }
}

export default CategoryPage;
